export default __webpack_public_path__ + "static/media/addHome3.540b3636.jpg";